export enum FollowUpActionType {
	None,
	AppIntegration,
	HumanHandover
}
